export * from './components';
export * from './adapters';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from "@omegagrid/core";
import rp, { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { componentFactories } from './factories';
import { Server } from '@reporting/rp-types/core';

export class SuperApplication extends Application {

	currentServer: Server;

	async init(container: Container) {
		super.init(container);
		container.services.register('accounting');
		container.services.register('definition');
		container.services.register('server');
		container.services.register('domain');
		this.getCurrentServer();
	}

	async getCurrentServer(): Promise<Server> {
		if (this.currentServer && this.currentServer.id_server === rp.accountingProvider.accounting.id_server) return this.currentServer;
		this.currentServer = await rp.ms('server').get<Server>(`/${rp.accountingProvider.accounting.id_server}`);
		return this.currentServer;
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
